import {
  Avatar,
  AvatarUserProps,
  AvatarComponentProps,
  cn,
} from '@fe-learner-common';
import { FC } from 'react';
import './AvatarGroup.css';

type AvatarGroupProps = AvatarComponentProps & {
  users: AvatarUserProps[];
  maxNoOfAvatars?: number;
};

const styleMap: Record<
  'xs' | 'md' | 'lg' | 'xl' | '2xl',
  {
    containerClassName: string;
    maskClassName: string;
  }
> = {
  xs: {
    containerClassName: 'lf:h-5',
    maskClassName: 'lf:-ml-1.5 avatar-mask-xs',
  },
  md: {
    containerClassName: ' lf:h-6',
    maskClassName: 'lf:-ml-2.5 avatar-mask-md',
  },
  lg: {
    containerClassName: ' lf:h-8',
    maskClassName: 'lf:-ml-3 avatar-mask-lg',
  },
  xl: {
    containerClassName: 'lf:h-10',
    maskClassName: 'lf:-ml-4 avatar-mask-xl',
  },
  '2xl': {
    containerClassName: ' lf:h-[72px]',
    maskClassName: 'lf:-ml-6 avatar-mask-2xl',
  },
};

export const AvatarGroup: FC<AvatarGroupProps> = ({
  users,
  size,
  maxNoOfAvatars = 4,
}) => {
  const { containerClassName, maskClassName } = styleMap[size];

  const avatars = users.slice(0, maxNoOfAvatars);
  return (
    <div
      className={cn(
        'lf:relative lf:z-10 lf:box-content lf:flex lf:flex-nowrap ',
        containerClassName,
      )}
    >
      {avatars.map((user, index) => (
        <Avatar
          className={cn(
            ' lf:box-border lf:border-2 lf:border-transparent',
            index !== 0 && maskClassName,
          )}
          key={index}
          {...user}
          size={size}
        />
      ))}
    </div>
  );
};
